
export const formatDate = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}

export const speakHindi = (text) => {
    if ('speechSynthesis' in window) {
        const speak = () => {
            const utterance = new window.SpeechSynthesisUtterance(text);
            const voices = window.speechSynthesis.getVoices();
            const voice =
                voices.find(v => v.lang === 'hi-IN' && v.name.toLowerCase().includes('female')) ||
                voices.find(v => v.lang === 'hi-IN') ||
                voices.find(v => v.lang === 'en-IN' && v.name.toLowerCase().includes('female')) ||
                voices.find(v => v.lang === 'en-IN') ||
                voices[0];
            if (voice) utterance.voice = voice;
            utterance.lang = voice?.lang || 'hi-IN';
            utterance.rate = 1;
            utterance.pitch = 1;
            window.speechSynthesis.speak(utterance);
        };
        if (window.speechSynthesis.getVoices().length === 0) {
            window.speechSynthesis.onvoiceschanged = speak;
            window.speechSynthesis.getVoices();
        } else {
            speak();
        }
    }
};